/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExportAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17.707 1.293 22.414 6l-4.707 4.707-1.414-1.414 2.351-2.352c-2.863-.051-4.389.468-5.25 1.329C12.4 9.266 12 10.998 12 14h-2c0-2.998.351-5.516 1.98-7.145 1.411-1.41 3.566-1.95 6.545-1.916l-2.232-2.232zM2 2h11v2H4v16h16v-9h2v11H2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExportAlt as ExportAlt };
